import { Environment } from "../enums";

const env = {
  SUPPORT_SOCKET_URL: "https://script.crmgenix.com/support",
  // SUPPORT_SOCKET_URL: "http://localhost:8084/support",
  APP_URL: "https://customizer.crmgenix.com",
  // APP_URL: "http://localhost:3002",
  // API_URL: "http://localhost:8084",
  API_URL: "https://script.crmgenix.com",
  
  GHL: {
    APP_ID: "69492732e1d858d52e969743",
    CLIENT_ID: "69492732e1d858d52e969743-mjh2mury",
    CLIENT_SECRET: "c43f83b0-980d-4c5a-bb59-08d90b60c3d5",
    SSO_KEY: "31d8c534-8b9e-47e5-bc5f-a29492d9288e",
  },
  SUPPORT_GHL: {
    APP_ID: "69452594b480b1848b1bf78d",
    CLIENT_ID: "69452594b480b1848b1bf78d-mjcpz80c",
    CLIENT_SECRET: "a14da703-7273-4515-8517-ad11fb7ca9d5",
    REDIRECT: `https://customizer.crmgenix.com/integrations/support`,
  },
CUSTOMIZR_MODULE_GHL: {
    APP_ID: "66f16d48c41d4d3f976b06dd",
    CLIENT_ID: "66f16d48c41d4d3f976b06dd-m1f1tr2k",
    CLIENT_SECRET: "978c10da-a016-4b2f-851e-636d2c980d57",
    REDIRECT: `https://customizer.crmgenix.com/integrations/customizer_module`,
  },
};
export default env;
